import type React from 'react'
import type { IconProps } from './types'

const AddIcon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z' />
	</svg>
)

export default AddIcon
